import React, { useState } from 'react';
import './css/whychooseus.css';
import BackImg from './images/services/6.jpg'
import { useLanguage } from '../contexts/LanguageContext';

const WhyChooseUs = () => {
  const { t } = useLanguage();
  const [expandedItem, setExpandedItem] = useState(0);

  const items = t('whyChooseUs.items');

  const toggleItem = (id) => {
    setExpandedItem(expandedItem === id ? null : id);
  };

  return (
    <section className="why-choose-section" dir="rtl">
      <div className="why-choose-container">
        <div className="content-wrapper">

          {/* Header */}
          <div className="section-header">
            <div className="header-tag">
              <span className="tag-line"></span>
              <span className="tag-text">{t('whyChooseUs.tag')}</span>
              <span className="tag-line"></span>
            </div>

            <h2 className="section-title">{t('whyChooseUs.title')}</h2>

            <p className="section-subtitle">
              {t('whyChooseUs.subtitle')}
            </p>
          </div>

          {/* Accordion Items */}
          <div className="accordion-container">
            {items.map((item) => (
              <div
                key={item.id}
                className={`accordion-item ${expandedItem === item.id ? 'expanded' : ''}`}
              >
                <div 
                  className="accordion-header"
                  onClick={() => toggleItem(item.id)}
                >
                  <h3 className="accordion-title">{item.title}</h3>
                  <button className="accordion-icon">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      className={expandedItem === item.id ? 'rotated' : ''}
                    >
                      <path
                        d="M7 10L12 15L17 10"
                        stroke="white"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </button>
                </div>

                {expandedItem === item.id && item.description && (
                  <div className="accordion-content">
                    <p className="accordion-description">{item.description}</p>
                  </div>
                )}
              </div>
            ))}
          </div>

        </div>
      </div>

      {/* Background Image */}
      <div className="background-image">
        <img
          src={BackImg}
          alt="Construction Background"
        />
        <div className="background-overlay"></div>
      </div>

    </section>
  );
};

export default WhyChooseUs;
